import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from './StyledToolTip';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  editIcon: {
    padding: '5px 10px',
    cursor: 'pointer',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    float: 'right',
    display: 'flex',
    alignItems: 'center',
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  }
});

const EditIconButton = ({
  classes,
  handleEdit,
  enableEdit,
  editEnableTooltip = 'Click to Edit',
  editDisabledTooltip = 'Select a row to edit'
}) => {
  return (
    <div
      className={`${classes.editIcon} ${enableEdit ? '' : classes.disableIcon}`}
      onClick={enableEdit ? handleEdit : undefined}>
      <Tooltip title={enableEdit ? editEnableTooltip : editDisabledTooltip}>
        <EditIcon />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(EditIconButton);
